module.exports = __webpack_public_path__ + "8c6a3558b7003115c8f71360f3e238a7.png";